import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkItemAgreements } from "../../data/WorkItemAgreementsHook";
import { useWorkItemCategories } from "../../data/WorkItemCategoriesHook";
import { useWorkOrderItems } from "../../data/WorkItemHook";
import { useWorkOrders } from "../../data/WorkOrdersHook";
import EngineerAvailability from "../engineerAvailability/EngineerAvailability";

function DomesticFieldReactiveWorkItemEdit() {
  const workItemAgreementsRepository = useWorkItemAgreements();
  const workItemCategoryRepository = useWorkItemCategories();
  const workItemsRepository = useWorkOrderItems();
  const workOrdersRepository = useWorkOrders();

  const workItem = workItemsRepository.getEntry();
  const workOrder = workOrdersRepository.getEntry();

  const updateAppointment = (date, slot, agreedoutsidesla) => {
    const current = workItemsRepository.getEntry();
    const revised = {
      ...current,
      agreedoutsidesla,
      preferredAppointmentDate: date,
      preferredAppointmentSlot: slot.id,
      preferredAppointmentSlotTitle: slot.title,
    };
    workItemsRepository.setEntry(revised);
  };

  const anyTimeSlot = { id: "PATS003", title: "Any time" };

  const updateAppointmentConfirmed = (e) => {
    const current = workItemsRepository.getEntry();
    const revised = {
      ...current,
      preferredAppointmentDate: "",
      preferredAppointmentSlot: anyTimeSlot.id,
      preferredAppointmentSlotTitle: anyTimeSlot.title,
      appointmentConfirmed: e.target.value,
      appointmentConfirmedTitle: e.target.selectedOptions[0].text,
    };
    workItemsRepository.setEntry(revised);
  };

  const updateWorkItemCategory = (e) => {
    const current = workItemsRepository.getEntry();

    const index = e.nativeEvent.target.selectedIndex;
    const workitemcategoryname = e.nativeEvent.target[index].text;

    const revised = {
      ...current,
      workitemcategoryid: e.target.value,
      workitemcategoryname,
    };
    workItemsRepository.setEntry(revised);
  };

  const updateJobSpecificAccessNotes = (e) => {
    const current = workItemsRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workItemsRepository.setEntry(revised);
  };

  const workItemAgreements =
    workItemAgreementsRepository.getWorkItemAgreements();
  const workItemCategories = workItemCategoryRepository.getWorkItemCategories();

  const appointmentData = {
    appointmentConfirmed: workItem.appointmentConfirmed,
    preferredAppointmentDate: workItem.preferredAppointmentDate
      ? new Date(workItem.preferredAppointmentDate)
      : "",
    slahours: workOrder.slahours,
    preferredAppointmentSlotTitle: workItem.preferredAppointmentSlotTitle,
  };

  return (
    <Container className="work-order-item-container">
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="workItemCategoryGroup">
            <Form.Label>Work Item Category</Form.Label>
            <Form.Select
              value={workItem.workitemcategoryid}
              onChange={updateWorkItemCategory}
            >
              {workItemCategories.map((nextItem) => (
                <option key={nextItem.id} value={nextItem.id}>
                  {nextItem.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group
            className="mb-3"
            controlId="preferredAppointmentSlotGroup"
          >
            <Form.Label>
              Will this be an agreed or not agreed appointment?
            </Form.Label>
            <Form.Select
              value={workItem.appointmentConfirmed}
              onChange={updateAppointmentConfirmed}
            >
              {workItemAgreements.map((nextItem) => (
                <option key={nextItem.id} value={nextItem.id}>
                  {nextItem.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <EngineerAvailability 
            updateAppointment={updateAppointment}
            appointmentData={appointmentData}
          />

          <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
            <Form.Label>Job Specific Access Notes</Form.Label>
            <Form.Control
              as="input"
              value={workItem.jobSpecificAccessNotes}
              onChange={updateJobSpecificAccessNotes}
            />
          </Form.Group>
        </Col>
      </Row>
    </Container>
  );
}

export default DomesticFieldReactiveWorkItemEdit;
